import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-youtube-competitor-identity',
  templateUrl: './help-youtube-competitor-identity.component.html'
})
export class HelpYoutubeCompetitorIdentityComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
